import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axiosInstance from "../../../utils/axiosInstance";
import { saveBot } from "../../shared/ApiEndpoint";
import { useNavigate } from "react-router-dom";
import { CurrentUserId } from "../../shared/shared";
import { createBotModal } from "../../shared/validation";
import { notification } from "antd";

const CreateBotModal = ({ show, setShow }) => {
  const navigate= useNavigate();
  const initialState = {
    bot_name: "",
    bot_desc: "",
  };
  const [newBot,setNewBot]= useState(initialState)
  const [errorValidate,setErrorValidate]= useState({
    bot_name: false,
    bot_desc: false
  });

    const handleOnChange = (e) => {
    const { name, value } = e.target;
    setNewBot({ ...newBot, [name]: value });
     if (value.trim() !== "") {
    setErrorValidate((prev) => ({ ...prev, [name]: false }));
  }
  };
 const handleClose=()=>{
  setShow(false);
  setNewBot(initialState);
  setErrorValidate({
    bot_name: false,
    bot_desc: false
  })
} 

  const handleSubmit = async() => {
    let isValid = true;

    const validations = {
      bot_name: !newBot.bot_name,
      bot_desc: !newBot.bot_desc,
    };
    Object.entries(validations).forEach(([key, hasError]) => {
      if(hasError) isValid = false;
    })
    setErrorValidate((prev) => ({
      ...prev,
      ...validations
    }))
    if(!isValid) return;
   const  payload={
     ...newBot,
      user_id:CurrentUserId,
    }
   try {
     const resp = await axiosInstance.post(saveBot, payload, {withCredentials: true});

    if (resp?.status === 200) {
      notification.success({
  message: "Bot created successfully",
  placement: "topRight",
  duration: 2, // optional
});
      const botId = resp?.data?.bot_id;
     navigate(`/bots/createBot?botid=${botId}`);
    }
   } catch (error) {
    console.log(error)
   }
  };
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create New Bot</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="botName">
            <Form.Label>Bot Name</Form.Label>
            <Form.Control type="text" placeholder="Enter bot name" name="bot_name" value={newBot.bot_name} onChange={handleOnChange} maxLength={30}/>
            {errorValidate.bot_name && <p className="text-danger">{createBotModal.bot_name}</p>}
          </Form.Group>

          <Form.Group className="mb-3" controlId="botDescription">
            <Form.Label>Bot Description</Form.Label>
            <Form.Control as="textarea" rows={2} placeholder="Enter bot description" name="bot_desc" value={newBot.bot_desc} onChange={handleOnChange} maxLength={130} />
           {errorValidate.bot_desc && <p className="text-danger">{createBotModal.bot_desc}</p>}
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              Create
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateBotModal;
